import { For, type Component } from 'solid-js';

import { PANELS } from '../game/keyboard';
import type { GameStore } from '../state/store';

/**
 * The row of panel buttons in the corner of the HUD.
 *
 * It exists because a keyboard shortcut nobody is told about may as well not
 * exist. Every panel is reachable by mouse *and* shows the key that opens it, so
 * the shortcuts teach themselves.
 *
 * The list comes from `game/keyboard.ts` — the same one the key router reads —
 * so a shortcut printed here is by construction the shortcut that works.
 */
export const HudMenu: Component<{ store: GameStore }> = (props) => (
  <nav class="hud-menu hud-interactive" data-testid="hud-menu" aria-label="Panels">
    <For each={PANELS}>
      {(entry) => (
        <button
          type="button"
          class="hud-menu__button"
          classList={{ 'hud-menu__button--open': props.store.menu() === entry.panel }}
          data-testid={`open-${entry.panel}`}
          aria-pressed={props.store.menu() === entry.panel}
          title={`${entry.label} (${entry.key})`}
          onClick={() => props.store.toggleMenu(entry.panel)}
        >
          <span class="hud-menu__sigil" aria-hidden="true">
            {entry.sigil}
          </span>
          <span class="hud-menu__label">{entry.label}</span>
          <span class="hud-menu__key">{entry.key}</span>
        </button>
      )}
    </For>
  </nav>
);
